import { useState, useEffect } from "react";
import { LinkOutlined } from "@ant-design/icons";
import { ConnectionStatus, User } from "../../../Interfaces/connections";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { getUsers } from "../../../Requests/connections";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import StaticDropdown from "../StaticDropdown";

interface Props {
  name: string;
  label: string;
  value?: number | string;
  onChange: (name: string, value: number) => void;
  disabled?: boolean;
  extraLabel?: boolean;
  getData?: (sensitiveTo: any) => Promise<User[]>;
  onDataFetch?: (users: User[]) => void;
  sensitiveTo?: any;
}
const UsersDropdown = ({
  label,
  name,
  onChange,
  value,
  disabled,
  extraLabel,
  getData,
  onDataFetch,
  sensitiveTo,
}: Props) => {
  const [users, setUsers] = useState<User[] | null>(null);

  const fetchUsers = () => {
    (getData ? getData(sensitiveTo) : getUsers())
      .then((resp) => {
        setUsers(resp);
        if (onDataFetch) onDataFetch(resp);
      })
      .catch(packetErrorHandler);
  };

  useEffect(() => {
    fetchUsers();
  }, [sensitiveTo]);

  const getItems = () => {
    if (!users) return [{ id: -1, name: "" }];
    const res: Array<DropdownItem> = [];
    if (users.length)
      users.map((option) => {
        res.push({
          id: option.id,
          name: option.name,
          prefix: option.hasConnectedAccount ? (
            <LinkOutlined title="اکانت متصل" />
          ) : undefined,
          additional: (
            <div
              className={`w-3 h-3 rounded-full ${
                option.connectionStatus === ConnectionStatus.Disconnected
                  ? "bg-red-700"
                  : null
              } ${
                option.connectionStatus === ConnectionStatus.Offline
                  ? "bg-gray-300"
                  : null
              } ${
                option.connectionStatus === ConnectionStatus.Online
                  ? "bg-green-600"
                  : null
              }`}
            />
          ),
        });
      });
    return res;
  };

  return (
    <StaticDropdown
      dropdown={{
        name: name,
        placeholder: label,
        disabled,
        extraLabel: extraLabel,
      }}
      // className: "mt-3",
      onChange={onChange}
      value={value}
      options={getItems()}
    />
  );
};

export default UsersDropdown;
